var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',{staticClass:"content"},[(_vm.content.ui_content_type === 'course')?_c('Course',{attrs:{"course":_vm.content,"isAuthenticated":_vm.isAuthenticated,"plansLink":_vm.plansLink,"learningAreaName":_vm.learningAreaName}}):_c('ContentDelegate',_vm._b({},'ContentDelegate',{
      content: _vm.content,
      contentType: _vm.content.ui_content_type,
      isAuthenticated: _vm.isAuthenticated,
      plansLink: _vm.plansLink,
    },false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }